<button mat-icon-button [matMenuTriggerFor]="colorMenu" [style.background-color]="selectedColor"
    aria-label="Select color" class="color-picker-trigger">

</button>

<mat-menu #colorMenu="matMenu">
    <div class="color-picker-grid">
        <button mat-icon-button *ngFor="let colorOption of colorPalette" [style.background-color]="colorOption.value"
            [attr.aria-label]="'Select ' + colorOption.name" (click)="selectColor(colorOption.value)"
            class="color-swatch" [class.selected]="colorOption.value === selectedColor">
        </button>
    </div>
</mat-menu>